import { IAppsResponse } from '../models/appsInitialize';
import { IAppsHydration } from '../models/appsInitialize/IAppsHydration';
import { pivotCollection } from '../utils/collection';
import { AppParamsHelper } from '../helpers/AppParamsHelper';
import { IManifest } from './models';
import { getAppKey } from './utils';

export class AppHydration {
	constructor(public hydrationKey: string) { }
	getAppHydration(
		manifest: IManifest,
		appParamsHelper: AppParamsHelper<any, any, any>,
	) {
		const hydrationId = getAppKey(manifest, appParamsHelper);
		const hydrationPoint = this.getHydrationPoint();
		return (
			hydrationPoint &&
			hydrationPoint.appsByKey &&
			hydrationPoint.appsByKey[hydrationId]
		);
	}
	getManagerHydration() {
		const hydrationPoint = this.getHydrationPoint();
		return hydrationPoint && hydrationPoint.manager;
	}
	mergeAppsResponses(appsResponses: IAppsResponse[]) {

		const javascriptPieces = [];
		if (appsResponses && appsResponses.length > 0) {
			const merged: IAppsResponse = { apps: [] };
			for (const appsResponse of appsResponses) {
				const { apps, manager, translations, javascript } = appsResponse;
				if (manager && typeof manager === 'object' && Object.keys(manager).length > 0) {
					merged.manager = manager;
				}
				if (apps && merged.apps) {
					merged.apps.push(...apps);
				}
				if (translations) {
					if (!merged.translations) {
						merged.translations = [];
					}
					merged.translations.push(...translations);
				}
				if (javascript) {
					javascriptPieces.push(javascript);
				}
			}
			if (javascriptPieces && javascriptPieces.length > 0) {
				merged.javascript = javascriptPieces.join('\n');
			}
			return merged;
		}
		return;
	}
	setHydrationPoint(
		appsResponse: IAppsResponse,
	) {
		let hydrationPoint: IAppsHydration = this.getHydrationPoint();
		if (!hydrationPoint) {
			hydrationPoint = {
				appsByKey: {},
			};
		}
		const mergedAppsResponse = this.mergeAppsResponses([hydrationPoint, appsResponse]);
		hydrationPoint = {
			...mergedAppsResponse,
			appsByKey: {
				...pivotCollection(
					mergedAppsResponse.apps || [],
					appResponse => appResponse.app.id || 'NO_ID',
				),
				...pivotCollection(
					mergedAppsResponse.apps || [],
					appResponse => `${ appResponse.app.id }|${ appResponse.app.applicationCode }`,
				),
			},
		};
		(window as any)[this.hydrationKey] = hydrationPoint;
	}

	getHydrationPoint(): IAppsHydration {
		if (!(window as any)[this.hydrationKey]) {
			(window as any)[this.hydrationKey] = {};
		}
		return (window as any)[this.hydrationKey];
	}
}